export default class HistoryGraph {}
